import { Typography } from '@mui/material';
import React from 'react';

import { FormFieldUIStatus } from '@occc-app/routes/Audience/utils';

interface IAttributeInfoProps {
  formFieldUIStatus: FormFieldUIStatus;
}

export const AttributeInfo = ({ formFieldUIStatus }: IAttributeInfoProps) => {
  if (formFieldUIStatus === 'error') {
    return <Typography color='error'>Attribute missing</Typography>;
  }

  if (formFieldUIStatus === 'filled') {
    return <Typography color='primary'>Attribute set</Typography>;
  }

  return null;
};
